/**
 * @module common/DualAxis/DualAxisPair
 * @description 主 Y 轴 + 次 Y 轴 布局容器
 */

import React from 'react';
import AxisSection, { type IAxisSectionProps } from './AxisSection';

export interface IDualAxisPairSectionConfig
  extends Pick<IAxisSectionProps, 'title' | 'className'> {
  key: string;
  content: React.ReactNode;
}

interface IDualAxisPairProps {
  sections: IDualAxisPairSectionConfig[];
  className?: string;
}

const DualAxisPair: React.FC<IDualAxisPairProps> = ({
  sections,
  className = '',
}) => (
  <div className={`dbl-dual-axis-pair ${className}`}>
    {sections.map(({ key, title, content, className: sectionClass }) => (
      <AxisSection key={key} title={title} className={sectionClass}>
        {content}
      </AxisSection>
    ))}
  </div>
);

export default React.memo(DualAxisPair);
